export default "__VITE_ASSET__FtFVDQ1$__"